import React, { useEffect, useState } from "react";
import CustomLoader from "../../Compoments/CustomeLoader";
import bannerimg2 from "../../utils/images/banner_img2.png";
import righticon from "../../utils/images/icon29.png";
import icon6 from "../../utils/images/icon22.png";
import icon7 from "../../utils/images/icon33.png";
import icon9 from "../../utils/images/icon9.png";
import icon16 from "../../utils/images/icon32.png";
import icon8 from "../../utils/images/icon30.png";
import icon10 from "../../utils/images/icon27.png";
import icon11 from "../../utils/images/right_icon.png";
import icon12 from "../../utils/images/icon24.png";
import icon13 from "../../utils/images/icon28.png";
import icon26 from "../../utils/images/icon26.png";
import icon25 from "../../utils/images/icon25.png";
import { config } from "../../config";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Form from 'react-bootstrap/Form';

function LifetimeAccess() {
    const [loading, setLoader] = useState(true);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [inquiry, setInquiry] = useState({
        full_name: "",
        email: "",
        phone_number: "",
        // solicitor_type: "solo",
        firm_name: "",
        user_count: "2-5",
        current_software: "",
        game_changing_feature: "",
        demo_access_opt_in: "false",
        refer_colleague: "",
        colleague_email: "",
    });

    const [errors, setErrors] = useState({});

    const validate = () => {
        const newErrors = {};

        if (!inquiry.full_name.trim()) {
            newErrors.full_name = "Full name is required";
        }

        if (!inquiry.email.trim()) {
            newErrors.email = "Email is required";
        } else if (/[A-Z]/.test(inquiry.email)) {
            newErrors.email = "Email must not contain capital letters";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inquiry.email)) {
            newErrors.email = "Invalid email format";
        }

        if (!inquiry.phone_number.trim()) {
            newErrors.phone_number = "Phone number is required";
        } else if (!/^\d{11}$/.test(inquiry.phone_number)) {
            newErrors.phone_number = "Phone number must be 11 numbers";
        }

        // if (inquiry.solicitor_type === "firm" && !inquiry.firm_name.trim()) {
        //   newErrors.firm_name = "Firm name is required";
        // }

        if (!inquiry.game_changing_feature.trim()) {
            newErrors.game_changing_feature = "This field is required";
        }

        if (inquiry.refer_colleague && !inquiry.colleague_email.trim()) {
            newErrors.colleague_email = "Colleague email is required";
        } else if (
            inquiry.refer_colleague &&
            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inquiry.colleague_email)
        ) {
            newErrors.colleague_email = "Invalid colleague email format";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;
        console.log(inquiry);

        try {
            const response = await fetch(`${config.localApiUrl}/api/createInquiry`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(inquiry),
            });
            const result = await response.json();
            if (result.Status === 200) {
                toast.success(result.Message);
                setInquiry({
                    full_name: "",
                    email: "",
                    phone_number: "",
                    // solicitor_type: "solo",
                    firm_name: "",
                    user_count: "2-5",
                    current_software: "",
                    game_changing_feature: "",
                    demo_access_opt_in: "false",
                    refer_colleague: "",
                    colleague_email: "",
                });
                handleClose();
            } else {
                toast.error(result.Message);
            }
        } catch (error) {
            console.log("Failed to create Data:", error.Message);
            toast.error("Failed to create Data.");
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (name === "phone_number") {
            const cleanedValue = value.replace(/\D/g, "");
            const formattedValue = cleanedValue.slice(0, 11);
            setInquiry({ ...inquiry, phone_number: formattedValue });
        } else {
            setInquiry({ ...inquiry, [name]: type === "checkbox" ? checked : value });
        }
        if (errors[name]) {
            setErrors({ ...errors, [name]: "" });
        }
    };

    useEffect(() => {
        setTimeout(() => {
            setLoader(false);
        }, 1000);
    }, []);
    return (
        <>
            {loading ? (
                <CustomLoader />
            ) : (
                <div className="lifetime-access">
                    <div className="lifetime-access-page">
                        <div className="banner-img">
                            <img src={bannerimg2} alt="" />
                        </div>
                        <div className="bg-color">
                            <div className="container">
                                <div className="banner-content">
                                    <div className="title">
                                        <h1>Lifetime Access</h1>
                                        <p>Revolutionising Legal Case Management</p>
                                    </div>
                                    <div className="social_icon">
                                        <a href="#">
                                            <img src={righticon} alt="" className="right-icon" />
                                        </a>
                                        <p>One-Time Licence Fee • £1,000 Per User</p>
                                    </div>
                                    <div className="social_icon social_icon2">
                                        <a href="#">
                                            <img src={righticon} alt="" className="right-icon" />
                                        </a>
                                        <p>
                                            No monthly subscriptions. No hidden fees. Just powerful
                                            legal software, forever.
                                        </p>
                                    </div>

                                    <div className="access-btn">
                                        <button
                                            title="Secure Lifetime Access Now"
                                            className="btn btn-primary"
                                            onClick={handleShow}
                                        >
                                            <div className="ripple_icon"></div> Secure Lifetime Access
                                            Now
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="built-solicitors-section">
                        <div className="container">
                            <div className="built-title">
                                <h2>Why Ivy?</h2>
                                <p>
                                    Legal software today is overpriced, outdated, and designed by
                                    tech companies, not solicitors. Ivy changes everything. We’re
                                    building Ivy for the future of legal practice
                                </p>
                            </div>
                            <div className="row padding-list">
                                <div className="col-sm-6 col-12 text-left">
                                    <div className="built-list-block">
                                        <div className="built-block-img">
                                            <img src={icon6} alt="" />
                                        </div>
                                        <div className="built-investment-text">
                                            <p>
                                                Built by solicitors who understand your daily challenges
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-12 text-left">
                                    <div className="built-list-block">
                                        <div className="built-block-img">
                                            <img src={icon7} alt="" />
                                        </div>
                                        <div className="built-investment-text">
                                            <p>
                                                All-in-one system covering matters, billing, clients,
                                                tasks, calendar and more
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-12 text-left">
                                    <div className="built-list-block">
                                        <div className="built-block-img">
                                            <img src={icon9} alt="" />
                                        </div>
                                        <div className="built-investment-text">
                                            <p>Backed by AI to boost efficiency and accuracy</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-12 text-left">
                                    <div className="built-list-block">
                                        <div className="built-block-img">
                                            <img src={icon16} alt="" />
                                        </div>
                                        <div className="built-investment-text">
                                            <p>
                                                Fast, secure and reliable – ready for remote and
                                                in-office use
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-12 text-left">
                                    <div className="built-list-block">
                                        <div className="built-block-img">
                                            <img src={icon8} alt="" />
                                        </div>
                                        <div className="built-investment-text">
                                            <p>Clean, intuitive design so nothing gets in your way</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="access-btn d-block d-md-none">
                                <button
                                    title="Secure Lifetime Access Now"
                                    className="btn btn-primary"
                                >
                                    <div className="ripple_icon"></div> Secure Lifetime Access Now
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="licence-includes-section">
                        <div className="container">
                            <div className="pricing-title">
                                <h2>Your Lifetime Licence Includes</h2>
                            </div>
                            <div className="pricing-box-block">
                                <div className="why-box">
                                    <div className="img">
                                        <img src={icon11} alt="" />
                                    </div>
                                    <h2>Full access to all Ivy features, forever</h2>
                                </div>
                                <div className="why-box">
                                    <div className="img">
                                        <img src={icon10} alt="" />
                                    </div>
                                    <h2>Use on desktop, tablet and mobiles</h2>
                                </div>
                                <div className="why-box">
                                    <div className="img">
                                        <img src={icon12} alt="" />
                                    </div>
                                    <h2>Free onboarding and data migration</h2>
                                </div>
                                <div className="why-box">
                                    <div className="img">
                                        <img src={icon13} alt="" />
                                    </div>
                                    <h2>Early access to AI-powered tools</h2>
                                </div>
                                <div className="why-box">
                                    <div className="img">
                                        <img src={icon26} alt="" />
                                    </div>
                                    <h2>Direct input into Ivy’s roadmap</h2>
                                </div>
                                <div className="why-box">
                                    <div className="img">
                                        <img src={icon25} alt="" />
                                    </div>
                                    <h2>
                                        Access for yourself or your firm (buy multiple licences)
                                    </h2>
                                </div>
                            </div>

                            <div className="access-btn">
                                <button
                                    title="Secure Lifetime Access Now"
                                    className="btn btn-primary"
                                    onClick={handleShow}
                                >
                                    <div className="ripple_icon"></div> Secure Lifetime Access Now
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <Modal show={show} onHide={handleClose} className="join_the_waitlist">
                <Modal.Header closeButton></Modal.Header>
                <Modal.Title>Ivy is launching soon.</Modal.Title>
                <Modal.Body>
                    <form className="join-modal" onSubmit={handleSubmit}>
                        <div className="form-group">
                            <div className="user-icon" />
                            <input
                                type="text"
                                placeholder="Full Name"
                                className="form-control"
                                onChange={handleChange}
                                name="full_name"
                                value={inquiry.full_name}
                            />
                            {errors.full_name && (
                                <p className="text-red-500 text-sm">{errors.full_name}</p>
                            )}
                        </div>

                        <div className="form-group">
                            <div className="email-icon" />
                            <input
                                type="email"
                                placeholder="Email address"
                                className="form-control"
                                onChange={handleChange}
                                name="email"
                                value={inquiry.email}
                            />
                            {errors.email && (
                                <p className="text-red-500 text-sm">{errors.email}</p>
                            )}
                        </div>

                        <div className="form-group">
                            <div className="phone-icon" />
                            <input
                                type="tel"
                                placeholder="Phone Number"
                                className="form-control"
                                onChange={handleChange}
                                name="phone_number"
                                value={inquiry.phone_number}
                            />
                            {errors.phone_number && (
                                <p className="text-red-500 text-sm">{errors.phone_number}</p>
                            )}
                        </div>
                        {/* <p className="text-head">Are you a solo solicitor or part of a firm?</p> */}

                        {/* <div className="custom-select-wrapper">
              <select className="custom-select" name="solicitor_type"
                value={inquiry.solicitor_type}
                onChange={handleChange}>
                <option value="solo">Solo</option>
                <option value="firm">Firm</option>
              </select>

            </div> */}

                        <div className="form-group">
                            <input
                                type="text"
                                placeholder="Firm Name"
                                className="form-control firm-name"
                                onChange={handleChange}
                                name="firm_name"
                                value={inquiry.firm_name}
                            />
                            {errors.firm_name && (
                                <p className="text-red-500 text-sm">{errors.firm_name}</p>
                            )}
                        </div>

                        <p className="text-head">how many users you have in your firm ?</p>
                        <div className="custom-select-wrapper">
                            <select
                                className="custom-select"
                                name="user_count"
                                value={inquiry.user_count}
                                onChange={handleChange}
                            >
                                <option>2-5</option>
                                <option>6-10</option>
                                <option>10+</option>
                            </select>
                        </div>
                        <p className="text-head">
                            Are you currently using any legal software? If yes, which one?
                        </p>
                        <div className="form-group">
                            <input
                                type="text"
                                placeholder="Enter software name"
                                className="form-control firm-name"
                                name="current_software"
                                value={inquiry.current_software}
                                onChange={handleChange}
                            />
                        </div>
                        <p className="text-head">
                            What feature would be a game changer for you in legal software?
                        </p>

                        <textarea
                            placeholder="Feature description here…"
                            className="form-control"
                            name="game_changing_feature"
                            value={inquiry.game_changing_feature}
                            onChange={handleChange}
                        />
                        {errors.game_changing_feature && (
                            <span className="text-red-500 text-sm">
                                {errors.game_changing_feature}
                            </span>
                        )}
                        <div className="custom-checkbox-block">
                            {/* <div className="custom-checkbox">
                <Form.Check aria-label="option 1" name="demo_access_opt_in"
                  checked={inquiry.demo_access_opt_in}
                  onChange={handleChange} defaultChecked />
                <label>Opt in for early demo beta access</label>
              </div> */}

                            <div className="custom-checkbox">
                                <Form.Check
                                    aria-label="option 1"
                                    name="refer_colleague"
                                    checked={inquiry.refer_colleague}
                                    onChange={handleChange}
                                />
                                <label>I'd like to refer a colleague</label>
                            </div>
                        </div>
                        {inquiry.refer_colleague && (
                            <div className="form-group">
                                <div className="email-icon" />
                                <input
                                    type="email"
                                    placeholder="Enter your colleague's email"
                                    className="form-control"
                                    name="colleague_email"
                                    value={inquiry.colleague_email}
                                    onChange={handleChange}
                                />
                                {errors.colleague_email && (
                                    <p className="text-red-500 text-sm">
                                        {errors.colleague_email}
                                    </p>
                                )}
                            </div>
                        )}

                        <button type="submit" className="btn btn-primary">
                            Join Waitlist
                        </button>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default LifetimeAccess;
